var map = {
	"./Account-Related.svg": "722d",
	"./Commission-Related.svg": "7e5c",
	"./Device-Related.svg": "6548",
	"./Product-Related.svg": "5fca",
	"./Transaction-Related.svg": "2a9f",
	"./Travel-Related.svg": "5e93",
	"./Wallet-Related.svg": "d28e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd8d";